<template>
	
  <div class="home">

   <div class="home-ct">

<div class="login">
	<div class="address">
		<div class="re-tit">
				   <h4>接收資訊</h4>
		</div>
		<div class="re-con">
			<ul>
				<li v-for="item in news" :class="{'ord-cook':item.id==address_id}" @click="ordCase(item)">
					<div class="l1">
						<span>{{item.name}}</span><span class="add-def"  v-if="item.if_default==1">默認地址</span>
					</div>
					<div class="l2">
						{{item.areaName}}
						{{item.address}}	
					</div>
					<div class="l3">
						<span>	{{item.phone}}</span>
					</div>
				</li>
			
				<router-link to="/user/address?ind=1"><li class="plus">
				<img src="../../assets/plus.png" />
				添加地址
				</li></router-link>
				<div class="clear"></div>
			</ul>
		</div>
	</div>

	<div class="login-r1">
	<div class="re-tit">
		<h4>帳單明細</h4>
			
	</div>
	
	
	<el-form :model="ruleForm"  label-width="100px"  label-position="top" size="mini" disabled >
		<el-row :gutter="20">
			 <el-col :span="12">
	  <el-form-item label="名字" prop="first_name">
	    <el-input v-model="ruleForm.first_name"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="姓" prop="last_name">
	    <el-input v-model="ruleForm.last_name"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 
	
	 
	 <el-row :gutter="20">
	 			 <el-col :span="12">
	  <el-form-item label="電話" prop="phone">
	    <el-input v-model="ruleForm.phone"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="昵稱" prop="nickname" >
	    <el-input v-model="ruleForm.nickname"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 
	 
	 <el-row :gutter="20">
	 			 <el-col :span="24">
	  <el-form-item label="國家/地區" prop="country">
	    <el-input v-model="ruleForm.country"></el-input>
	  </el-form-item>
	  </el-col>

	 </el-row>
	 <el-row :gutter="20">
	 		
	  <el-col :span="24">
	  <el-form-item label="ID" prop="identity_id">
	    <el-input v-model="ruleForm.identity_id" placeholder="大陸和臺灣必須填寫身份證號碼"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 <el-row :gutter="20">
	 			 <el-col :span="24" >
	  <el-form-item label="地址行" prop="address_line">
	    <el-input v-model="ruleForm.address_line"></el-input>
	  </el-form-item>
	  </el-col>
	
	 </el-row>

	 <el-row :gutter="20">
	 	 <el-col :span="24">
	  <el-form-item label="省" prop="province">
	    <el-input v-model="ruleForm.province"></el-input>
	  </el-form-item>
	  </el-col>
	
	  </el-col>
	 </el-row>
	 <el-row :gutter="20">
	 
	  <el-col :span="24">
	  <el-form-item label="城鎮/都市" prop="city">
	    <el-input v-model="ruleForm.city"></el-input>
	  </el-form-item>
	  </el-col>
	
	 </el-row>
	 <el-row :gutter="20">

	  <el-col :span="24">
	  <el-form-item label="郵遞區號/郵遞區號" prop="postcode">
	    <el-input v-model="ruleForm.postcode"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 <el-row>
	
	  </el-row>
	 <el-row :gutter="20">
	
	 </el-row>
	 
	
	  </el-form-item>
	</el-form>
	

	<div class="re-tit">
		<h4>附加資訊</h4>
		
		
	</div>
	
	
	<el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px"  label-position="top"  size="mini"  >


	 <el-row :gutter="20" v-if="ruleForm.country=='South Korea'">
	 			 <el-col :span="24">
	  <el-form-item label="清關程式碼或birt日期" prop="korean_code">
	    <el-input v-model="form.korean_code"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 <el-row :gutter="20">
	 			 <el-col :span="24">
	  <el-form-item label="訂單說明（可選）" prop="remark">
	    <el-input type="textarea" v-model="form.remark"></el-input>
	  </el-form-item>
	  
	  </el-col>
	
	 </el-row>

	
	  </el-form-item>
	</el-form>
	</div>
	<div class="login-r2">
		<div class="re-tit">
			<h4>您的訂單</h4>
			
			
		</div>
	
		<div class="ord-cart" >
				<div class="cart-tit">
					<h4>產品</h4>
					
							</div>
							<div class="cart-con">
								<ul>
									<li v-for="item in roll">
										<div class="lt">
										<div class="pic">
											<img :src="item.image" />
										</div>
										<div class="txt">
											<p>{{item.title}}</p><p>{{item.num}}×CN ¥ {{item.price_sale}}</p>
										</div>
										</div>
									
									</li>
							</ul>
							</div>
							<div class="cart-bot">
								<div class="l1">
									<h4>小計</h4>
									<h4>$ {{price}}</h4>
								</div>
								<div class="l1">
									<h4>入場券</h4>
									<h4>{{buff.voucher_num}} 可獲得的</h4>
								</div>
								<div class="l1" @click="full">
									<h4>優惠券</h4>
									<h4>CN ¥ {{coupon||0}}</h4>
								</div>
								<div class="l4" v-if="feed">
									<p v-for="item in buff.yhq_list"><span>${{item.jian}} {{item.title}} </span>
									<el-button size="mini" v-if="kid" @click="coupons(item)" round>使用</el-button>
								
									</p>
								</div>
								<div class="l1" v-if="buff.jifen_pay.if_open==1">
									<h4>你可以使用 {{buff.jifen_pay.jifen}} 積分兌換 {{buff.jifen_pay.money}} </h4>
									<div v-if="sandy" @click="holl(false)"> <img src="../../assets/fid.png"></div><div v-else @click="holl(true)"> <img src="../../assets/fid2.png"></div>
								</div>
								<div class="l1">
									<h4>運費</h4>
									<h4>CN ¥ {{buff.yunfei||0}}</h4>
								</div>
								<div class="l3">
									<h4>總計</h4>
									<h4>{{total}}</h4>
									<!-- <h4 v-if="buff.yunfei">$ {{price+buff.yunfei}}</h4>
									<h4 v-else>$ {{price}}</h4> -->
								</div>
							
							</div>
								
				   
		</div>
		
		<div class="ord-cart" >
			<!-- <div class="ord-cir">
		
			<img class="p1" src="../../assets/fid.png" />	PAYPAL <img class="p2" src="../../assets/paypal.png" />
			</div> -->
		
					
					<div class="ord-cir" @click="type=2">
							
					<img v-if="type==2" class="p1" src="../../assets/fid.png" /><img v-else class="p1" src="../../assets/fid2.png" />微信支付 <img class="p2" src="../../assets/wech.png" />
					</div>
						<div class="ord-cir" @click="type=3">
							
						<img v-if="type==3" class="p1" src="../../assets/fid.png" /><img v-else class="p1" src="../../assets/fid2.png" />	ALIPAY <img class="p2" src="../../assets/alipay1.png" />
						</div>		
				   
		</div>
		<div class="h-button" @click="sandBlue">下單</div>

	</div>
	<div class="clear"></div>

	
</div>
   </div>

    </div>
</template>
<script>


export default {

  data() {
    return {
	news:'',
		page:1,
		pagenum:100,
		kid:true,
		address_id:'',
		roll:'',
		total:0,
		price:0,
		buff:'',
		coupon:0,
		yhq:'',
		ic:0,
		type:2,
		feed:false,
		chort:true,
		sandy:false,
		form:{
			korean_code:'',
			remark:''
		},
           ruleForm: {
           	first_name:'',
           	last_name:'',
                    
           	phone:'',
           	nickname:'',
           	country:'',
           	identity_id:'',
           	address_line:'',
           	province:'',
           	city:'',
           	postcode:'',
           			moren: 0,
                     
               
                 },
                  rules: {
					
					  email: [
					    { required: true, message: 'Please fill in email', trigger: 'blur' },
				],password: [
					    { required: true, message: 'Please fill in password', trigger: 'blur' },
				]
                 
                  },product_info:[]
          };
  },  mounted() {
	
	   
	  this.yhq = this.$route.query.yhq
	  this.ic = this.$route.query.ic
		if(this.$route.query.sandy=='true'){
			this.sandy=true
		}else{
			this.sandy=false
		}
		
		this.sandMate();
		this.sandCart()
	
	
		},methods: {
			sandCart(){
				this.price=0;
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_lists",
				  data: {},  
				}).then((res) => {
					let data=res.data;
					
					
					if(data.code==1){
						this.roll=data.data;
						
					
						this.roll.forEach((item, index) => {
						
						
							this.price =this.price+item.price_sale * item.num
							
							this.product_info.push({
									"inventoryId": item.inventoryId,
									"productId": item.productId,
									"num": item.num
								})
								this.sandCase();
							
						})
						
					}
				 
				});
			},
			
		 submitForm(formName) {
			
			      
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		         this.$axios({
		           method: "post",
		           url: "service.php?action=users_emailLogin",
		           data: this.ruleForm,  
		         }).then((res) => {
		         	let data=res.data;
		         			
		         	if(data.code==1){
						
						localStorage.setItem("user", JSON.stringify(data.data));
			
		     this.$alert(data.message, '提示', {
		              confirmButtonText: '确定',
		              callback: action => {
		              this.$router.push({ path: "/" });	
		              }
		            });
		         		
		         	}else{  
						this.$message.error(data.message);
						      
					}
		          
		         });
				 
				 
		          } else {
		           
		            return false;
		          }
		        });
		      },
			  holl(pic){
			  	this.sandy=pic
			  	if(this.sandy){
			  		this.total=this.price-this.coupon+this.buff.yunfei-this.buff.jifen_pay.money
					this.total=Number(this.total).toFixed(2)
			  	}else{
			  		this.total=this.price-this.coupon+this.buff.yunfei
					this.total=Number(this.total).toFixed(2)
			  	}
			  },
			  full(){
			  	this.feed=true
			  },
			  ordCase(item){
				this.address_id=item.id  
				this.sandRill()
				this.sandCase()
			  },
			  sandRill(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=userAddress_detail",
			  	  data: {id:this.address_id},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  					
			  			this.ruleForm=data.data;
			  		
			  		}
			  	 
			  	});
			  
			  },
			  coupons(item){
				  if(this.kid){
					  this.yhq=item.id;
					  this.coupon=item.jian;
					if(this.sandy){
						this.total=this.price-this.coupon+this.buff.yunfei-this.buff.jifen_pay.money
						this.total=Number(this.total).toFixed(2)
					}else{
						this.total=this.price-this.coupon+this.buff.yunfei
						this.total=Number(this.total).toFixed(2)
					}
				  }
				
			  },
			  sandRed(id){
				  if(this.type==2){
					   this.$router.push({ path: "/product/pay?id="+id });	 
				  }else{
					  this.$router.push({ path: "/product/pays?id="+id });	 
				  }
				 
				  
			 //  	this.$axios({
			 //  	  method: "post",
			 //  	  url: "service.php?action=paypal_pay",
			 //  	  data: {order_id:id},  
			 //  	}).then((res) => {
			 //  		let data=res.data;
			  
			 //  		if(data.code==1){
			  			
				// 		window.open(data.data.link)
				
			 //  		}
			  	 
			 //  	});
			  
			  },
			  sandCase(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=orders_getPayInfo",
			  	  data: {address_id:this.address_id,product_info:JSON.stringify(this.product_info)},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  					
			  			this.buff=data.data;
						
						this.buff.yhq_list.forEach((item,index)=>{
							if(item.yhqId==this.ic){
								this.coupons(item)
							}
						})
						
						if(this.sandy){
							this.total=this.price-this.coupon+this.buff.yunfei-this.buff.jifen_pay.money
							this.total=Number(this.total).toFixed(2)
						}else{
							this.total=this.price-this.coupon+this.buff.yunfei
							this.total=Number(this.total).toFixed(2)
						}
					
			  		
			  		}
			  	 
			  	});
			  
			  },
			  sandBlue(){
				  if(this.address_id==''){
					  this.$message.error("請選擇送貨地址");
					  return
				  }
				  if(this.chort){
					  this.chort=false
					  this.$axios({
					    method: "post",
					    url: "service.php?action=orders_create",
					    data: {address_id:this.address_id,product_info:JSON.stringify(this.product_info),korean_code:this.form.korean_code,remark:this.form.remark,yhq_id:this.yhq},  
					  }).then((res) => {
					  	let data=res.data;
					  			  
					  if(data.code==1){
					  						
					  						
					  			
					  this.$alert(data.message, '提示', {
					           confirmButtonText: '確認',
					           callback: action => {
					  			 
					  			 if(this.sandy){
					  				 this.$axios({
					  				   method: "post",
					  				   url: "service.php?action=orders_jifenPay",
					  				   data: {order_id:data.order_id,jifen:this.buff.jifen_pay.jifen},  
					  				 }).then((res) => {
					  				 
					  				 
					  				 	if(data.code==1){
					  				 		
					  				 	  this.sandRed(data.order_id)
					  				 			this.chort=true
					  				 	}
					  				  
					  				 });
					  			 }else{
					  				 this.sandRed(data.order_id)
					  			 }
					  			
					  			  
					  	
					  
					  	   
					           }
					         });
					      		
					      	}else{  
					  						this.$message.error(data.message);
					  						      
					  					}
					   
					  });
				  }
			  	
			  
			  },
			  sandMate(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=userAddress_lists",
			  	  data: {page:this.page,pagenum:this.pagenum},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  	
			  							
			  			this.news=data.data;
			  			
			  			
			  		}
			  	 
			  	});
			  
			  },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;
		
			padding: 0 50px;
			height: 50px;
			line-height: 50px;
			background: #000;
			color: #FFFFFF;
			margin-top: 30px;
		
		}
		.h-button:hover{
			background-color: #333333;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			h4{
				font-size: 26px;
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{
	width:500px;
	float: left;
	padding-right: 50px;
}
.login-r2{
	width:530px;
background-color: #F8F8F8;
	padding: 50px;
	float: left;

}
.address{
	.re-con{
		li{
			font-size: 14px;
			width: 374px;
			height: 190px;
			background: #F8F8F8;
			border: 1px solid #D2D2D2;
			float: left;
			margin-right: 23px;
			margin-bottom: 20px;
			.l1{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px dotted #DDDDDD;
				padding: 0 20px;
				position: relative;
				.add-def{
					width: 123px;
					height: 33px;
					line-height: 33px;
					text-align: center;
					background: #0A0A0A;
					color: #FFFFFF;
					position: absolute;
					top: 0;
					right: 20px;
				}
			}
.l2{
			
				height: 50px;
				line-height: 2;
				border-bottom: 1px dotted #DDDDDD;
				padding:15px 20px;
			}
			.l3{
				font-size: 15px;
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
		
				padding: 0 20px;
			}
			
		}
		.ord-cook{
			background: url(../../assets/up.png) no-repeat right bottom;
		}
		.plus{
			display: flex;
			flex-direction:column ;
			justify-content: center;
			align-items: center;
			img{
				width: 33px;
				height: 33px;
			}
		}
	}
}
::v-deep .el-input__inner {
   border-radius: 0;
}
	.ord-cart{
		margin-bottom: 20px;
		background: #FFFFFF;
	
		border: 1px solid #eeeeee;
		.cart-tit{
			height:70px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 20px;
			border-bottom: 1px solid #eeeeee;
			h4{
				font-size: 16px;
			}
			img{
				width: 11px;
				height: 10px;
			}
		}
		.cart-but{
			margin-top: 20px;
		}
		.cart-con{
			
			li{
				padding: 20px;
				display: flex;
				font-size: 14px;
				border-bottom: 1px solid #eeeeee;
				justify-content: space-between;
				.pic{
					width: 115px;
					height: 77px;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.txt{
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					margin-left: 10px;
					
				}
				.lt{
					display: flex;
				}
				
				
			}
		}
		.cart-bot{
		
			padding: 20px;
			border-top: 1px solid #eeeeee;
			.l1{
				display: flex;
				line-height: 50px;
				justify-content: space-between;
				border-bottom: 1px solid #eeeeee;
				font-size: 14px;
				span{
					font-weight: normal;
					margin-left: 10px;
				}
			}
			.l3{
				font-size: 24px;
				display: flex;
				line-height: 50px;
				justify-content: space-between;
			
			}
			.l4{
				p{
				
					display: flex;
					height: 50px;
					justify-content: space-between;
					align-items: center;
					border-bottom: 1px dotted #DDDDDD;
					padding: 0 20px;
				}
				
			}
		}
		.ord-cir{
			display: flex;
			padding: 20px;
			line-height: 50px;
			align-items: center;
			border-bottom: 1px solid #F1F1F1;
			.p1{
			
				margin-right: 10px;
			}
			.p2{
			margin-left: 10px;
			}
		}
	}
</style>